import PropTypes from 'prop-types';
import React from 'react';

import IconBounds from '../IconBounds';
import { Download } from '../shapes';


const DownloadSvg = (props) => (
  <g>
    <IconBounds />
    <Download {...props} />
  </g>
);

DownloadSvg.propTypes = {
  fill: PropTypes.string,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.number,
};

DownloadSvg.defaultProps = {
  fill: '#000',
  stroke: '#000',
  strokeWidth: 1,
};


export default DownloadSvg;
